import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SetupGuide: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Helvetica Neue, Arial, sans-serif",
        backgroundColor: "#e5e5e5",
      }}
    >
      <h1 style={{ color: "#333", textAlign: "center", marginBottom: "40px" }}>
        AI LINE BOT マニュアル
      </h1>

      <section id="line-account" style={sectionStyle}>
        <h2>🔥 Step0. LINE公式アカウントにログインor作成</h2>
        <p>
          既にお持ちの方はスキップ
          <a
            href="https://account.line.biz/signup"
            target="_blank"
            rel="noopener noreferrer"
          >
            LINE公式アカウント登録
          </a>{" "}
          にアクセス
        </p>
        <ul>
          <li>「LINEでログイン」または「ビジネスアカウント（メールアドレス登録）」を選択</li>
          <li>ビジネス情報（会社名・業種など）を入力</li>
          <li>アカウント作成完了 → LINE Official Account Manager にログイン</li>
        </ul>
        <div style={imageContainerStyle}>
          <img src="/images/login.png" alt="LINEログイン画面" style={imageStyle} />
          <img src="/images/registration.png" alt="LINEビジネスアカウント登録" style={imageStyle} />
        </div>
      </section>

      <section id="line-settings" style={sectionStyle}>
        <h2>🔥 Step1. LINE公式設定（プロバイダ & チャネル作成）（約 3分）</h2>
        <p>LINE Developers で API を利用するために、プロバイダ（フォルダのようなもの）を作成し、その中に「チャネル（Messaging API）」を作成します。</p>
        <ol>
          <li><a href="https://developers.line.biz/console/" target="_blank" rel="noopener noreferrer">LINE Developers コンソール</a> にアクセス</li>
          <li>「プロバイダを作成」ボタンをクリック（例：「AI LINE BOT」など適当な名前）</li>
          <li>作成したプロバイダを開き、「チャネルを作成」ボタンをクリック</li>
          <li>「Messaging API」を選択</li>
          <li>Developerアカウント作成ページに遷移 → 業種・使用用途を入力して登録</li>
          <li>登録後、LINE Developers コンソールにログイン</li>
        </ol>
        <div style={imageContainerStyle}>
          <img src="/images/create_provider.png" alt="プロバイダ作成" style={imageStyle} />
          <img src="/images/create_channel.png" alt="チャネル作成" style={imageStyle} />
        </div>
      </section>

      <section id="line-api-data" style={sectionStyle}>
        <h2>🔥 Step2. AI LINE BOT(基本設定)（約 3分）</h2>
        <ul>
          <li>「Messaging API」設定ページを開く「チャネルシークレット」を表示し、メモしておく</li>
          <li>「チャネルアクセストークンを発行」ボタンをクリック、発行されたアクセストークンをメモしておく</li>
        </ul>
        <div style={imageContainerStyle}>
          <img src="/images/channel_secret.png" alt="チャネルシークレット" style={imageStyle} />
          <img src="/images/access_token.png" alt="アクセストークン" style={imageStyle} />
        </div>
      </section>

      <section id="ai-line-bot" style={sectionStyle}>
        <h2>🔥 Step3. AI LINE BOT(受け答え設定)（約 3分）</h2>
        <ol>
          <li>AI LINE BOT管理ページにログイン</li>
          <li>受け答え設定から「プロンプト」を登録、受け答えは商品説明ページをコピペなどを元にChatGPTに依頼</li>
          <li>LINE連携のデータ（シークレットキー & アクセストークン）を登録。「Webhook URL」が発行される</li>
        </ol>
        <div style={imageContainerStyle}>
          <img src="/images/signup.png" alt="サインアップ" style={imageStyle} />
          <img src="/images/regist_prompt.png" alt="プロンプト" style={imageStyle} />
        </div>
      </section>

      <section id="webhook" style={sectionStyle}>
        <h2>🔥 Step4. LINE公式設定（Webhook有効化 & 挨拶・チャット無効化）（約 2分）</h2>
        <p>作成したチャネルで API を正しく動作させるため、Webhook を有効化し、デフォルトのメッセージを無効化します。</p>
        <ol>
          <li>LINE Developers にログイン → 作成した「Messaging API」チャネルを開く</li>
          <li>「Messaging API 設定」タブを開く</li>
          <li>「Webhookの利用」→「ON」「応答メッセージ」→「無効」「あいさつ」→「無効」「チャット」→「無効」に変更</li>
          <li>「Webhook URL」に3で発行された値を貼り付け</li>
        </ol>
        <div style={imageContainerStyle}>
          <img src="/images/setting.png" alt="messageapi有効化" style={imageStyle} />
          <img src="/images/webhook_url.png" alt="webhookurl" style={imageStyle} />
        </div>
      </section>

      <section id="test" style={sectionStyle}>
        <h2>🔥 Step5. AI LINE BOT(受け答え設定)（約 5分）</h2>
        <ul>
          <li>公式アカウントのQAコードから友だち追加</li>
          <li>メッセージを送信 → AIが自動応答するか確認</li>
          <li>応答内容が意図通りでない場合、プロンプトを調整</li>
        </ul>
        <div style={imageContainerStyle}>
          <img src="/images/demo1.png" alt="デモ１" style={imageStyle} />
          <img src="/images/edit_prompt.png" alt="プロンプトの編集" style={imageStyle} />
        </div>
      </section>

      <section id="summary" style={sectionStyle}>
        <h2>🔥 まとめ（所要時間：約 10〜20分）</h2>
        <table border={1} cellPadding={10} style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}>
          <thead style={{ backgroundColor: "#f2f2f2" }}>
            <tr>
              <th style={{ border: "1px solid #ccc" }}>手順</th>
              <th style={{ border: "1px solid #ccc" }}>所要時間</th>
            </tr>
          </thead>
          <tbody>
            <tr><td style={{ border: "1px solid #ccc" }}>Step1. LINE公式設定（プロバイダ & チャネル作成）</td><td style={{ border: "1px solid #ccc" }}>3分</td></tr>
            <tr><td style={{ border: "1px solid #ccc" }}>Step2. AI LINE BOT(基本設定)</td><td style={{ border: "1px solid #ccc" }}>3分</td></tr>
            <tr><td style={{ border: "1px solid #ccc" }}>Step3. AI LINE BOT(受け答え設定)</td><td style={{ border: "1px solid #ccc" }}>3分</td></tr>
            <tr><td style={{ border: "1px solid #ccc" }}>Step4. LINE公式設定（Webhook有効化 & 挨拶・チャット無効化）</td><td style={{ border: "1px solid #ccc" }}>2分</td></tr>
            <tr><td style={{ border: "1px solid #ccc" }}>Step5. AI LINE BOT(受け答え設定)</td><td style={{ border: "1px solid #ccc" }}>5分</td></tr>
            <tr><td style={{ border: "1px solid #ccc" }}><strong>💡 合計</strong></td><td style={{ border: "1px solid #ccc" }}><strong>約 10分</strong></td></tr>
          </tbody>
        </table>
      </section>
    </div>
  );
};

const sectionStyle: React.CSSProperties = {
  marginBottom: "30px",
  padding: "24px",
  border: "1px solid #ddd",
  borderRadius: "12px",
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
};

const imageContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  gap: "16px",
  marginTop: "16px",
  flexWrap: "wrap",
};

const imageStyle: React.CSSProperties = {
  width: "48%",
  maxWidth: "400px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};

export default SetupGuide;
